export default __webpack_public_path__ + "static/media/github.350947f8.svg";